<template>
  <list-view-cell :context-menu-items="contextMenuItems">
    <p>{{ task.name }}</p>

    <template #bottom>
      <div class="px-4 pb-6">
        <p>
          Assigned To: <span class="font-bold">{{ task.assignee }}</span>
        </p>
        <p>Scheduled: {{ task.scheduled_for }}</p>
        <p class="mt-2">
          Priority Level: <span class="capitalize">{{ task.priority }}</span>
        </p>

        <bdg-aside class="my-5" title="Description">
          {{ task.description }}
        </bdg-aside>

        <div class="flex flex-col w-full mb-4">
          <bdg-files-list section-name="ATTACHED FILES:" :items="task.files" />
          <bdg-file-uploader class="mt-3" />
        </div>

        <div class="flex justify-end">
          <input type="checkbox" />
          <label>Completed</label>
        </div>
      </div>
    </template>
  </list-view-cell>
</template>

<script>
import ListViewCell from "../ListViewCell";
import { ContextMenuItem } from "../../../../helper-classes/ContextMenuItem";
import BdgAside from "../../../BdgAside";
import BdgFilesList from "../../../files-list/BdgFilesList";
import BdgFileUploader from "../../../files-list/BdgFileUploader";
import ScopeItemTaskForm from "../../../../views/contracts/forms/ScopeItemTaskForm";

export default {
  name: "ScopeItemTaskCell",
  components: { BdgFileUploader, BdgFilesList, BdgAside, ListViewCell },
  props: {
    task: Object
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: ScopeItemTaskForm,
            createEditComponentData: this.task,
            createEditComponentIsShown: true
          });
        }),
        new ContextMenuItem("delete", () => {
          this.$store.commit("setConfirmationModalParams", {
            type: "delete",
            headerText: "Delete Confirmation",
            bodyComponent: undefined,
            bodyComponentData: this.task,
            isShown: true
          });
        })
      ]
    };
  }
};
</script>

<style scoped></style>
